module.exports = __webpack_public_path__ + "static/media/coil.682760d2.glb";